import { render } from "./AuthorEmail.vue?vue&type=template&id=c1f3022a&scoped=true"
import script from "./AuthorEmail.vue?vue&type=script&lang=js"
export * from "./AuthorEmail.vue?vue&type=script&lang=js"

import "./AuthorEmail.vue?vue&type=style&index=0&id=c1f3022a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f3022a"]])

export default __exports__